export default "__VITE_ASSET__78b1c7e7__"